// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * How an SSH session is opened.
 */
export class SshOptions implements flatbuffers.IUnpackableObject<SshOptionsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SshOptions {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSshOptions(bb: flatbuffers.ByteBuffer, obj?: SshOptions): SshOptions {
    return (obj || new SshOptions()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSshOptions(bb: flatbuffers.ByteBuffer, obj?: SshOptions): SshOptions {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SshOptions()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * The server host key fingerprint the client must see, in OpenSSH
   * `SHA256:<base64>` form. Required unless `accept_any_host_key` is set.
   */
  hostKeyFingerprint(): string | null;
  hostKeyFingerprint(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  hostKeyFingerprint(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Accept whatever host key the server presents. Logged as a warning, with
   * the fingerprint seen, on every connect.
   */
  acceptAnyHostKey(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Command run with `exec`; empty requests a shell instead.
   */
  command(): string | null;
  command(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  command(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Request a pseudo-terminal first. The terminal is put in raw mode (no echo,
   * no line editing, no signal characters, no CR/NL translation, no output
   * processing) so binary vendor frames pass through unchanged.
   */
  requestPty(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startSshOptions(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addHostKeyFingerprint(
    builder: flatbuffers.Builder,
    hostKeyFingerprintOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, hostKeyFingerprintOffset, 0);
  }

  static addAcceptAnyHostKey(builder: flatbuffers.Builder, acceptAnyHostKey: boolean) {
    builder.addFieldInt8(1, +acceptAnyHostKey, +false);
  }

  static addCommand(builder: flatbuffers.Builder, commandOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, commandOffset, 0);
  }

  static addRequestPty(builder: flatbuffers.Builder, requestPty: boolean) {
    builder.addFieldInt8(3, +requestPty, +false);
  }

  static endSshOptions(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSshOptions(
    builder: flatbuffers.Builder,
    hostKeyFingerprintOffset: flatbuffers.Offset,
    acceptAnyHostKey: boolean,
    commandOffset: flatbuffers.Offset,
    requestPty: boolean,
  ): flatbuffers.Offset {
    SshOptions.startSshOptions(builder);
    SshOptions.addHostKeyFingerprint(builder, hostKeyFingerprintOffset);
    SshOptions.addAcceptAnyHostKey(builder, acceptAnyHostKey);
    SshOptions.addCommand(builder, commandOffset);
    SshOptions.addRequestPty(builder, requestPty);
    return SshOptions.endSshOptions(builder);
  }

  unpack(): SshOptionsT {
    return new SshOptionsT(
      this.hostKeyFingerprint(),
      this.acceptAnyHostKey(),
      this.command(),
      this.requestPty(),
    );
  }

  unpackTo(_o: SshOptionsT): void {
    _o.hostKeyFingerprint = this.hostKeyFingerprint();
    _o.acceptAnyHostKey = this.acceptAnyHostKey();
    _o.command = this.command();
    _o.requestPty = this.requestPty();
  }

  unpackFields(...fields: string[]): SshOptionsT {
    const t = new SshOptionsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("host_key_fingerprint")) {
      t.hostKeyFingerprint = this.hostKeyFingerprint();
    }
    if (fieldSet.has("accept_any_host_key")) {
      t.acceptAnyHostKey = this.acceptAnyHostKey();
    }
    if (fieldSet.has("command")) {
      t.command = this.command();
    }
    if (fieldSet.has("request_pty")) {
      t.requestPty = this.requestPty();
    }
    return t;
  }
}

export class SshOptionsT implements flatbuffers.IGeneratedObject {
  constructor(
    public hostKeyFingerprint: string | Uint8Array | null = null,
    public acceptAnyHostKey: boolean = false,
    public command: string | Uint8Array | null = null,
    public requestPty: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const hostKeyFingerprint =
      this.hostKeyFingerprint !== null ? builder.createString(this.hostKeyFingerprint!) : 0;
    const command = this.command !== null ? builder.createString(this.command!) : 0;

    return SshOptions.createSshOptions(
      builder,
      hostKeyFingerprint,
      this.acceptAnyHostKey,
      command,
      this.requestPty,
    );
  }

  clone(): SshOptionsT {
    const obj = new SshOptionsT();
    obj.hostKeyFingerprint = this.hostKeyFingerprint;
    obj.acceptAnyHostKey = this.acceptAnyHostKey;
    obj.command = this.command;
    obj.requestPty = this.requestPty;
    return obj;
  }

  equals(other: SshOptionsT): boolean {
    if (this.hostKeyFingerprint !== other.hostKeyFingerprint) return false;
    if (this.acceptAnyHostKey !== other.acceptAnyHostKey) return false;
    if (this.command !== other.command) return false;
    if (this.requestPty !== other.requestPty) return false;
    return true;
  }
}

export function verifySshOptions(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
  } finally {
    verifier.popDepth();
  }
}
